.content-overlay-open--fixed {
  overflow: hidden;
}
.content-block-overlay-container {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
content-overlay {
  display: none;
  position: relative;
  flex: 0;
  .content-overlay__content>*[slot="content"] {
    height: 100%;
    overflow: auto;
  }
  &.content-overlay-active {
    display: flex;
  }
  &[vertical="left"] {
    align-items: flex-start;
  }
  &[vertical="center"] {
    align-items: center;
  }
  &[vertical="right"] {
    align-items: flex-end;
  }
  
  &[vertical="top"] {
    justify-content: flex-start;
    top: 0;
  }
  &[vertical="center"] {
    justify-content: center;
  }
  &[vertical="bottom"] {
    justify-content: flex-end;
    bottom: 0;
  }
  
  .content-overlay-background {
    background: rgba(255,255,255,.6);
    bottom: 0;
    display: none;
    top: 0;
    z-index: 100000;
    right: 0;
    left: 0;
    width: 100%;
    &.active {
      display: block;
    }
  }
  .content-overlay__header {
    display: flex;
    align-items: center;
  }
  .content-overlay__close {
    order: 2;
    margin-left: auto;
    cursor: pointer;
    z-index: 1;
    appearance: none;
    background: none;
    border: none;
    min-width: 40px;
    // color: white;
    // &:after {
    //   content: "\00d7";
    //   font-size: 2.5rem;
    // }
  }

  &[position="fixed"] {
    .content-overlay-background {
      position: fixed;
    }
  }

  &[position="absolute"] {
    position: absolute;
    box-sizing: border-box;
    z-index: 100000;
    height: 100%;
    width: 100%;
    left: 0;
    .content-overlay-background {
      position: static;
    }
  }

  &[position="absolute"],
  &[position="fixed"] {
    .content-overlay__content {
      flex: 1;
      overflow: auto;
    }
  }

  [role="dialog"] {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    &.hidden {
      display: none;
    }
  }
  &[full-screen="true"] {
    height: 100%;
    .content-overlay-background { 
      height: 100%;
    }
  }
}

/* this is added to the body when a dialog is open */
body.has-dialog {
  overflow: hidden;
}
// .content-overlay--no-fullscreen {
//   position: relative;
//   .content-overlay-background {
//     position: static;
//   }
//   [role="dialog"] {
//     top: 0;
//     bottom: 0;
//     left: 0;
//     right: 0;
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     transform: none;
//   }
// }
